import { ApiResult } from 'interfaces/APITypes';

import { buildAxiosResult } from 'utils/axios';

import { mytoverInstance } from './client';

export interface TrialRequestPayload {
  app: string;
  name: string;
  email: string;
  token: string;
}

export const requestTrial = async (serial: string, payload: TrialRequestPayload): Promise<ApiResult> => {
  const response = await mytoverInstance.post(`/units/${serial}/trial`, payload, {
    validateStatus: (status) => status < 500,
  });
  return buildAxiosResult(response);
};
